import React from 'react';

/** A row of toggle buttons, one pressed, each reading "Label · count", or "Label" without a count. */
const Segments = ({ label, options, value, onChange }) => (
  <div className="td-act-toggle td-drill__segments" role="group" aria-label={label}>
    {options.map((o) => (
      <button key={o.key} type="button" aria-pressed={o.key === value} onClick={() => onChange(o.key)}>
        {o.count == null ? o.label : `${o.label} · ${o.count}`}
      </button>
    ))}
  </div>
);

export default Segments;
